// extracted by mini-css-extract-plugin
export default {"getStarted":"MKR4VxMIFVx03n7ZtUxM","getStartedPlaceholder":"TeXF1YdtrCRiB9HS1gYK","description":"emYeGi0G1QExJgNV8yG2","title":"E_h0nFOcQ9GTs8WvzHgX","field":"nNnc_t4fUcPnKY8phVuQ"};